/** Where the DaVinci connector is listed (#679). There is no store listing yet: null means "behave as if there were no connector". */
export const CONNECTOR_STORE_URL: string | null = null;
